module.exports = "<span [ngStyle]=\"{'border-color': label.group.color}\">{{label.name}}</span>\n"